import type { Role } from '../api/types';

export type PageKey =
  | 'today' | 'daily' | 'hourly' | 'channels' | 'products' | 'menu' | 'alerts' | 'accuracy' | 'inputs' | 'influencers'
  | 'upload' | 'settings' | 'group' | 'group_settings' | 'data_sharing' | 'users' | 'prep' | 'quiet';

const STAFF: PageKey[] = ['today', 'daily', 'hourly', 'products', 'prep'];
const SITE_MANAGER: PageKey[] = [...STAFF, 'alerts', 'inputs', 'quiet', 'upload', 'settings'];
const AREA_MANAGER: PageKey[] = [...SITE_MANAGER, 'channels', 'menu', 'accuracy', 'influencers', 'group'];
const GROUP_OWNER: PageKey[] = [...AREA_MANAGER, 'group_settings', 'data_sharing', 'users'];

export const PAGES_BY_ROLE: Record<Role, ReadonlySet<PageKey>> = {
  staff: new Set(STAFF),
  site_manager: new Set(SITE_MANAGER),
  area_manager: new Set(AREA_MANAGER),
  group_owner: new Set(GROUP_OWNER),
};

export function canSee(role: Role, page: PageKey): boolean {
  return PAGES_BY_ROLE[role].has(page);
}

export const ROLE_LABELS: Record<Role, string> = {
  group_owner: 'Group owner',
  area_manager: 'Area manager',
  site_manager: 'Site manager',
  staff: 'Staff',
};

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  group_owner: 'Everything, including billing, users and data sharing',
  area_manager: 'All sites they are assigned, including group view',
  site_manager: 'Forecasts, alerts, inputs, uploads and settings for their sites',
  staff: 'Today, hourly, product forecasts and the prep plan',
};
